'use client'

import { QueryClientProvider as LibQueryClientProvider } from '@tanstack/react-query'

import { useState, type PropsWithChildren } from 'react'
import { makeNewQueryClient } from '@/app/utils/queryClient'

export function QueryClientProvider({ children }: PropsWithChildren) {
  const [queryClient] = useState(makeNewQueryClient())

  return <LibQueryClientProvider client={queryClient}>{children}</LibQueryClientProvider>
}
